import { gen2Request } from 'src/services/gen_2_http_reqs';

export async function getObserverLists(device) {
	return await gen2Request(device, `BLE.CloudRelay.List`, {}, false, true);
}

export async function addToObserverList(device, mac) {
	return await gen2Request(
		device,
		`BLE.CloudRelay.Add`,
		{
			addr: mac,
		},
		false,
		true,
	);
}

export async function removeFromObserverList(device, mac) {
	return await gen2Request(
		device,
		`BLE.CloudRelay.Remove`,
		{
			addr: mac,
		},
		false,
		true,
	);
}
